// 基础host（默认本地、可选择第三方服务器）
let baseHost = '/static/base';
// let baseHost = 'https://pcdn.youjiate.club/base'

let config = {
  //默认包含商城
  includeMall: true,
  images: {
    base: {
      answerSheet:{
        bg: baseHost+'/img/answerSheet/bg.png',
        mistakes: baseHost +'/img/answerSheet/mistakes.png',
        noData: baseHost+'/img/answerSheet/no-data.png',
        rocketFilled: baseHost+'/img/answerSheet/RocketFilled.png'
      },
      help:{
            background: baseHost+'/img/help/background.jpg',
            computer: baseHost+'/img/help/computer.png',
            makeVideo : baseHost+'/img/help/make-video.png',
            mobile: baseHost+'/img/help/mobile.png',
            onlineCustomer: baseHost+'/img/help/online-customer.png',
            operationManual: baseHost + '/img/help/operation-manual.png',
            play: baseHost+'/img/help/play.png',
            qr:baseHost+'/img/help/qr.png',
      },
      home: {
        bg1: baseHost + "/img/home/bg1.png",
        top: baseHost + "/img/home/top.png",
        ico: baseHost + "/img/home/ico.png",
        constructor: baseHost + "/img/home/constructor.png",
        engineer: baseHost + "/img/home/engineer.png",
        vehicleRepairing: baseHost + "/img/home/vehicle-repairing.png",
        teaArt: baseHost + "/img/home/tea-art.png",
        player: baseHost + "/img/home/player.png",
        resource: baseHost + "/img/home/resource.png",
        course: baseHost + "/img/home/course.png",
        teacher: baseHost + "/img/home/teacher.png",
        people: baseHost + "/img/home/people.png",
        move: baseHost + "/img/home/move.png",
        unicom: baseHost + "/img/home/unicom.png",
        telecom: baseHost + "/img/home/telecom.png",
        integrity: baseHost + "/img/home/integrity.png",
        high: baseHost + "/img/home/high.png",
        brand: baseHost + "/img/home/brand.png",
        phone: baseHost + "/img/home/phone.png",
        bottom: baseHost + "/img/home/bottom.png",
        no1: baseHost + '/img/dashboard/no1.png',
        no2: baseHost + '/img/dashboard/no2.png',
        no3: baseHost + '/img/dashboard/no3.png',
        numberStaff: baseHost + '/img/dashboard/numberStaff.png',
        schoolStatistics: baseHost + '/img/dashboard/schoolStatistics.png',
        numberTraining: baseHost + '/img/dashboard/numberTraining.png',
        balanceOfAccount: baseHost + '/img/dashboard/balanceOfAccount.png',
        entUserHomeBackground: baseHost + '/img/dashboard/entUserHomeBackground.jpg'
      },
      supervise: {
        background: baseHost + '/img/supervise/background.png',
        enterprise: baseHost + '/img/supervise/enterprise.png',
        head: baseHost + '/img/supervise/head.png',
        label: baseHost + '/img/supervise/label.png',
        number: baseHost + '/img/supervise/number.png',
        time: baseHost + '/img/supervise/time.png',
        no1: baseHost + '/img/supervise/no.1.png',
        no2: baseHost + '/img/supervise/no.2.png',
        no3: baseHost + '/img/supervise/no.3.png',
      },
      jgLogin: {
        backgroundImage: baseHost + '/img/jglogin/back.jpg',
        loginTopImage: baseHost + '/img/jglogin/login-top-image.jpg'
      },
      login: {
        backgroundImage: baseHost + '/img/login/background.jpg',
        backgroundOrgImage: baseHost + '/img/login/background-org.jpg',
        iconSignIn: baseHost + '/img/login/icon_sign_in.png',
      },
      register: {
        backgroundImage: baseHost + '/img/register/background.jpg',
        userIcon: baseHost + '/img/register/user-icon.png',
        entIcon: baseHost + '/img/register/ent-icon.png',
        success: baseHost + '/img/register/success.png'
      },
      employee: {
        qCodeStop: baseHost + '/img/employee/qCodeStop.png'
      },
      recommend: {
        backgroundImage: baseHost + '/img/recommend/background.png',
        backgroundImagePc: baseHost + '/img/recommend/background-pc.png',
        backgroundImagePerson: baseHost + '/img/recommend/background-person.png',
        qr: baseHost + '/img/recommend/qr.png',
        pc: baseHost + '/img/recommend/pc.png',
        applets: baseHost + '/img/recommend/applet.png',
      },
      mall: {
        toTop: baseHost + '/img/mall/toTop.png',
        list: {
          backd: baseHost + '/img/mall/list/backd.png'
        },
        topNav: {
          user: baseHost + '/img/mall/topNav/user.jpg'
        },
        rightNav: {
          enterpriseTerminal: baseHost + '/img/mall/rightNav/enterpriseTerminal.png',
          onlineCustomerService: baseHost + '/img/mall/rightNav/onlineCustomerService.png',
          personalSide: baseHost + '/img/mall/rightNav/personalSide.png'
        },
        detail: {
          pay: baseHost + '/img/mall/mallplay.png'
        },
        about: {
          entIcon: baseHost + '/img/mall/about/ent-icon.png',
          postalCodeIcon: baseHost + '/img/mall/about/postal-code-icon.png',
          linkFunIcon: baseHost + '/img/mall/about/link-fun-icon.png',
          background: baseHost + '/img/mall/about/background.png',
          email: baseHost + '/img/mall/about/email.png',
          entIntroduce: baseHost + '/img/mall/about/ent-introduce.png',
          linkMe: baseHost + '/img/mall/about/link-me.png',
        }
      },
      recharge: {
        reb: baseHost + '/img/recharge/reb.jpg'
      }
    }
  },
  files: {
    //操作手册
    helpFile: baseHost + '/file/操作手册.pdf',
    template: {
      userBr: baseHost + '/file/template/补录模版.xlsx',
      userBatch: baseHost + '/file/template/批量学员信息导入模板.xlsx',
      questionBatchImport: baseHost + '/file/template/批量导入试题模版.xlsx',
    }
  }
}

export default config



// WEBPACK FOOTER //
// ./src/config/config_base.js